import { render, staticRenderFns } from "./DailyPurchases.vue?vue&type=template&id=ebd553e6&scoped=true"
import script from "./DailyPurchases.vue?vue&type=script&lang=js"
export * from "./DailyPurchases.vue?vue&type=script&lang=js"
import style0 from "./DailyPurchases.vue?vue&type=style&index=0&id=ebd553e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd553e6",
  null
  
)

export default component.exports